import { render, staticRenderFns } from "./PreviewDocument.vue?vue&type=template&id=4a4ff769&scoped=true"
import script from "./PreviewDocument.vue?vue&type=script&lang=ts"
export * from "./PreviewDocument.vue?vue&type=script&lang=ts"
import style0 from "./PreviewDocument.vue?vue&type=style&index=0&id=4a4ff769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ff769",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VImg})
